import SMRestClient from 'lib/SMRestClient';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import sprintf from 'sprintf';
import SMConst from 'lib/SMConst';

class SMOwnerResource {

  static postOwner(formData, completion){
    const url = "/1/owners.json";
    const apiClient = new SMRestClient();
    apiClient.post(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static updateOwner(id, formData, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/owners/" + id + ".json" + q;
    const apiClient = new SMRestClient();
    apiClient.patch(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static postMessage(reservation, formData, completion){
    const url = "/1/owners/" + reservation.owner.username + "/reservations/" + reservation.uid + "/messages.json";
    const apiClient = new SMRestClient();
    apiClient.post(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static getReservation(ownerId, id, completion){
    const apiClient = new SMRestClient();
    apiClient.get("/1/owners/"+ ownerId +"/reservations/"+ id +".json").
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static getReputation(reservation, completion){
    const url = "/1/owners/"+ reservation.owner.id +"/reservations/"+ reservation.id +"/reputation.json";
    const apiClient = new SMRestClient();
    apiClient.get(url).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static postReputation(reservation, formData, completion){
    const url = "/1/owners/"+ reservation.owner.id +"/reservations/"+ reservation.id + "/reputation.json";
    const apiClient = new SMRestClient();
    apiClient.post(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static updateReputation(reservation, formData, completion){
    const url = "/1/owners/"+ reservation.owner.id +"/reservations/"+ reservation.id + "/reputation.json";
    const apiClient = new SMRestClient();
    apiClient.patch(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static getReservations(ownerId, queries, completion){
    queries["per_page"] = queries["per_page"] || 20;
    const q = SMFormatHelper.getUrlArgString(queries);
    const apiClient = new SMRestClient();
    apiClient.get("/1/owners/"+ ownerId +"/reservations.json" + q).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static searchReservations(ownerId, queries, completion){
    queries["per_page"] = queries["per_page"] || 20;
    const q = SMFormatHelper.getUrlArgString(queries);
    const apiClient = new SMRestClient();
    apiClient.get("/1/owners/"+ ownerId +"/search/reservations.json" + q).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static getDashboard(ownerId, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const apiClient = new SMRestClient();
    apiClient.get("/1/owners/"+ ownerId +"/dashboard.json" + q).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static getAnalytics(ownerId, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const apiClient = new SMRestClient();
    apiClient.get("/1/owners/"+ ownerId +"/analytics.json" + q).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static confirm(reservation, formData, completion){
    const url = sprintf("/1/owners/%s/reservations/%s/confirm",
      reservation.owner.username, reservation.id);
    const apiClient = new SMRestClient();
    apiClient.patch(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static reject(reservation, formData, completion){
    const url = sprintf("/1/owners/%s/reservations/%s/reject",
      reservation.owner.username, reservation.id);
    const apiClient = new SMRestClient();
    apiClient.patch(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static cancel(reservation, formData, completion){

    const url = sprintf("/1/owners/%s/reservations/%s/cancel",
      reservation.owner.username, reservation.id);
    const apiClient = new SMRestClient();
    apiClient.patch(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static refund(reservation, formData, completion){
    const url = sprintf("/1/owners/%s/reservations/%s/refund",
      reservation.owner.username, reservation.id);
    const apiClient = new SMRestClient();
    apiClient.patch(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static changePrice(reservation, formData, completion){
    const url = "/1/owners/"+ reservation.owner.username +"/reservations/"+ reservation.id +"/change_price";
    const apiClient = new SMRestClient();
    apiClient.patch(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static getRoom(ownerId, roomId, completion){
    const url = "/1/owners/" + ownerId + "/rooms/" + roomId + ".json";
    const apiClient = new SMRestClient();
    apiClient.get(url).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static getRooms(ownerId, queries, completion){
    queries["per_page"] = queries["per_page"] || 20;
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/owners/"+ ownerId +"/rooms.json";
    const apiClient = new SMRestClient();
    apiClient.get(url + q).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static deleteRoom(owner, id, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/owners/" + owner.id + "/rooms/" + id + ".json" + q;
    const apiClient = new SMRestClient();
    apiClient.destroy(url).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static postRoom(owner, formData, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/owners/" + owner.id + "/rooms.json" + q;
    const apiClient = new SMRestClient();
    const request = apiClient.post(url, formData);
    request.
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
    return request;
  }

  static updateRoom(owner, id, formData, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/owners/" + owner.id + "/rooms/" + id + ".json" + q;
    const apiClient = new SMRestClient();
    const request = apiClient.patch(url, formData);
    request.
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
    return request;
  }

  static updateRoomWithJson(owner, id, payload, queries, completion) {
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/owners/" + owner.id + "/rooms/" + id + ".json" + q;
    const apiClient = new SMRestClient();
    const request = apiClient.patchWithJson(url, payload);
    request.
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
    return request;
  }

  static requestReview(ownerId, completion){
    const url = "/1/owners/"+ ownerId +"/request_review.json";
    const apiClient = new SMRestClient();
    apiClient.patch(url).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static requestRoomReview(ownerId, roomId, completion){
    const url = "/1/owners/"+ ownerId + "/rooms/"+ roomId +"/request_review.json";
    const apiClient = new SMRestClient();
    apiClient.patch(url).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static getSpaces(ownerId, queries, completion){
    queries["per_page"] = queries["per_page"] || 20;
    const q = SMFormatHelper.getUrlArgString(queries);
    const apiClient = new SMRestClient();
    apiClient.get("/1/owners/"+ ownerId + "/search/spaces.json" + q).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static getCalendar(ownerId, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const apiClient = new SMRestClient();
    apiClient.get("/1/owners/" + ownerId + "/calendar.json" + q).
      done((data, textStatus, xhr)=>{
        completion(data, null, xhr);
      }).
      fail((xhr, textStatus, error)=> {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static getRoomCalendar(ownerId, roomId, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const apiClient = new SMRestClient();
    apiClient.get(`/1/owners/${ownerId}/rooms/${roomId}/calendar.json${q}`).
      done((data, textStatus, xhr) => {
        completion(data, null, xhr);
      }).
      fail((xhr, textStatus, error) => {
        completion(null, error, xhr);
      });
  }

  static postReservation(ownerId, formData, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = `/1/owners/${ownerId}/reservations/manuals.json${q}`;
    const apiClient = new SMRestClient();
    apiClient.post(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        completion(null, error, xhr);
      });
  }

  static updateReservation(ownerId, reservationId, formData, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = (queries.mediator == SMConst.ReservationMediator.OwnerDirect) ? `/1/owners/${ownerId}/reservations/manuals/${reservationId}.json`
                                                                              : `/1/owners/${ownerId}/reservations/${reservationId}.json`;
    const apiClient = new SMRestClient();
    apiClient.patch(url+q, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        completion(null, error, xhr);
      });
  }

  static deleteReservation(ownerId, reservationId, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = `/1/owners/${ownerId}/reservations/manuals/${reservationId}.json`;
    const apiClient = new SMRestClient();
    apiClient.destroy(url).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        completion(null, error, xhr);
      });
  }

  static postConcierge(formData, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/concierges";
    const apiClient = new SMRestClient();
    apiClient.post(url, formData).
      done((data, textStatus, xhr) => {
        completion(data, null, xhr);
      }).
      fail((xhr, textStatus, error) => {
        completion(null, error, xhr);
      });
  }

  static getOwnerSales(ownerId, queries, completion){
    queries["page"] = queries["page"] || 1;
    queries["per_page"] = queries["per_page"] || 20;
    const q = SMFormatHelper.getUrlArgString(queries);
    const apiClient = new SMRestClient();
    apiClient.get("/1/owners/"+ ownerId +"/sales.json" + q).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static approveReservation(reservation, formData, completion){
    const url = sprintf("/1/owners/%s/reservations/%s/approve_change",
      reservation.owner.username, reservation.id);
    const apiClient = new SMRestClient();
    apiClient.patch(url, formData).
    done(function(data, textStatus, xhr) {
      completion(data, null, xhr);
    }).
    fail(function(xhr, textStatus, error) {
      console.error(error);
      completion(null, error, xhr);
    });
  }

  static rejectReservation(reservation, formData, completion){
    const url = sprintf("/1/owners/%s/reservations/%s/reject_change",
      reservation.owner.username, reservation.id);
    const apiClient = new SMRestClient();
    apiClient.patch(url, formData).
    done(function(data, textStatus, xhr) {
      completion(data, null, xhr);
    }).
    fail(function(xhr, textStatus, error) {
      console.error(error);
      completion(null, error, xhr);
    });
  }
}
export default SMOwnerResource;



// WEBPACK FOOTER //
// ./app/javascript/resources/SMOwnerResource.js